import { getRestaurants, type Restaurant } from '../restaurant/apiHelpers';

export const restaurantsLoader = async (): Promise<Restaurant[]> =>
  getRestaurants();
